/**
 * Narrows an export's row list to the rows the user ticked.
 *
 * Consumed by `useArTableExport` and `createArTableExportSnapshot`, in both cases
 * on the output of `resolveArTableBundleExportVisibility` and never before it:
 * classifying a selection subset orphans members whose header is unticked and
 * fails them closed (SYD-2279). The PDF (`ArTableBody` in PDF-export mode) does
 * the opposite — it intersects the selection before classifying — so with a hide
 * flag active it drops ticked members whose header is unticked while the XLSX
 * keeps them. That divergence only ever withholds rows from the PDF, never
 * discloses.
 *
 * An absent or empty selection exports everything.
 */

import type { ArRowId } from '#types/System.Artifacts.types';

function filterArRowIdsBySelection({
  rowIds,
  selectedRowIds,
}: {
  rowIds: readonly ArRowId[];
  selectedRowIds: readonly ArRowId[] | null;
}): ArRowId[] {
  if (!selectedRowIds || selectedRowIds.length === 0) return [...rowIds];
  const selected = new Set(selectedRowIds);
  return rowIds.filter((rowId) => selected.has(rowId));
}

export { filterArRowIdsBySelection };
